import { AxiosError } from 'axios';
import instance from '../config/axios';
import { NonOrderableProductItem } from '../interface/interface';

export async function getNonOrderableProducts(
  token: string,
): Promise<Array<NonOrderableProductItem> | null> {
  try {
    const result = await instance({
      url: '/api/v1/products/non-orderable',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return result.data;
  } catch (e) {
    const error = e as AxiosError;
    console.log(
      'Unable to fetch non orderable products',
      error.response?.status,
    );

    return null;
  }
}
